/**
 * Converts a string to title case format, capitalizing the first letter of each word
 * and converting the rest to lowercase. Also replaces underscores with spaces.
 *
 * @param str - The input string to be converted to title case
 * @returns The string converted to title case with underscores replaced by spaces
 *
 * @example
 * ```typescript
 * toTitleCase("hello world")           // "Hello World"
 * toTitleCase("HELLO WORLD")           // "Hello World"
 * toTitleCase("hello_world")           // "Hello World"
 * toTitleCase("user_name_field")       // "User Name Field"
 * toTitleCase("camelCaseString")       // "CamelCaseString"
 * toTitleCase("multiple___underscores") // "Multiple   Underscores"
 * ```
 */
export function toTitleCase(str: string) {
	return str
		.replace(
			/\w\S*/g,
			(text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
		)
		.replace(/_/g, " ");
}
